import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Register.vue')
  },
  {
    path: '/user-center',
    name: 'UserCenter',
    component: () => import(/* webpackChunkName: "user" */ '@/views/UserCenter.vue')
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫：检查登录状态，如果URL中有token参数则保存并同步用户信息
router.beforeEach(async (to, from, next) => {
  // 检查URL参数中是否有token（从PC端跳转过来时传递的）
  const tokenParam = to.query.token
  if (tokenParam && typeof tokenParam === 'string') {
    // 如果URL中有token参数，保存到localStorage并同步用户信息
    const currentToken = localStorage.getItem('token')
    if (tokenParam !== currentToken) {
      console.log('[Merchant] 从URL参数获取到token，保存并同步用户信息')
      localStorage.setItem('token', tokenParam)
      store.commit('auth/SET_TOKEN', tokenParam)
      
      // 同步用户信息
      try {
        await store.dispatch('auth/syncUser')
      } catch (error) {
        console.error('同步用户信息失败:', error)
      }
      
      // 保留activeMenu参数（用于激活特定标签页），移除token参数避免泄露
      const newQuery = { ...to.query }
      const activeMenu = newQuery.activeMenu
      delete newQuery.token
      // 如果只有activeMenu参数，保留它；否则移除token后保留其他参数
      if (activeMenu) {
        next({ path: to.path, query: { activeMenu }, replace: true })
      } else {
        next({ path: to.path, query: newQuery, replace: true })
      }
      return
    }
  }
  
  // 检查是否需要登录（访问user-center时需要）
  if (to.path === '/user-center') {
    const isAuthenticated = store.getters['auth/isAuthenticated']
    const token = localStorage.getItem('token')
    
    if (!isAuthenticated && !token) {
      // 如果没有登录且没有token，跳转到登录页
      next('/login')
      return
    } else if (token && !isAuthenticated) {
      // 如果有token但store中没有认证状态，尝试同步用户信息
      try {
        await store.dispatch('auth/syncUser')
        next()
        return
      } catch (error) {
        console.error('同步用户信息失败:', error)
        next('/login')
        return
      }
    }
  }
  
  next()
})

export default router

